var React = require('react');

function IconMapSettingsCenterMarkerActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#30B4C0","fillRule":"evenodd","d":"M12.589 26.478A1.589 1.589 0 0 1 11 24.888v-13.82c0-.878.711-1.59 1.589-1.59h15.889a1.59 1.59 0 0 1 1.589 1.59V24.89a1.59 1.59 0 0 1-1.59 1.589h-4.56l-3.5 4-3.5-4h-4.328v-.001zM19.5 2h2v3h-2V2zm0 33h2v3h-2v-3zM38 19v2h-3v-2h3zM6 19v2H3v-2h3z"}));
}

IconMapSettingsCenterMarkerActive.defaultProps = {"width":"40","height":"40"};

module.exports = IconMapSettingsCenterMarkerActive;

IconMapSettingsCenterMarkerActive.default = IconMapSettingsCenterMarkerActive;
